import { render, staticRenderFns } from "./FormularioGeoserver.vue?vue&type=template&id=15fd4376&"
import script from "./FormularioGeoserver.vue?vue&type=script&lang=js&"
export * from "./FormularioGeoserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports